import { createContext, type Context } from 'react';

export const ConnectorsLoadingContext: Context<boolean> = createContext(true);
